import { BackendError } from './BackendError';

// The backend has provided information indicating that the node server is
// running back it can't do anything useful because the database it relies on
// is down.
export class DatabaseUncontactableError extends BackendError {
  static errorName = 'DatabaseUncontactableError';
}
